export default __webpack_public_path__ + "strongher-second-screens@2x.02553583.png";